import { Icon } from '@kanda-libs/ks-design-library';
import type { OpenBankingInfoPopoverProps } from '..';
import useOptionPopoverDesktop from './useOptionPopoverDesktop';

const OptionPopoverDesktop: React.FunctionComponent<OpenBankingInfoPopoverProps> =
  function ({ children }) {
    const { elementRef, visible } = useOptionPopoverDesktop();
    return (
      <div ref={elementRef} className="z-50 relative my-auto">
        <Icon
          icon="info"
          className="w-4 cursor-pointer min-w-4 text-neutral-500 ml-2"
          size={16}
          stroke="neutral-500"
        />
        {visible && (
          <div className="absolute bottom-8 right-0 px-4 py-5 border border-neutral-200 bg-neutral-000 rounded-lg shadow-popover min-w-80">
            {children}
          </div>
        )}
      </div>
    );
  };

export default OptionPopoverDesktop;
